import DefaultLayout from '../../../layout/DefautlLayout';
import Header from '../../../components/header/Header';
import { Link } from 'react-router-dom';
import TreatmentIntroBanner from '../../../components/treatmentBanner/treatmentBanner';

const TeethWhiteningPage = () => {
	const prices = [{ label: 'Treatment', value: '€220/£150' }];

	return (
		<DefaultLayout>
			<Header />
			<div id="Content">
				<div className="content_wrapper clearfix">
					<div className="sections_group">
						<div className="extra_content">
							<TreatmentIntroBanner
								title="Teeth Whitening"
								description="Professional in-office bleaching that safely brightens your smile using peroxide-based whitening under clinical supervision—delivering fast, visible results tailored for long-term dental health and cosmetic enhancement."
								quote=" Brighten your smile, boost your confidence. "
								backgroundImage="/assets/images/banners/treatment-xl-2.png"
							/>

							<div className="section mcb-section" id="image" style={{ paddingBottom: '70px' }}>
								<div className="section_wrapper mcb-section-inner">
									<div className="wrap mcb-wrap one valign-top clearfix">
										<div className="mcb-wrap-inner">
											<div className="column mcb-column one-third column_image">
												<div className="image_frame image_item scale-with-grid aligncenter has_border hrmargin_b_30">
													<div className="image_wrapper">
														<div className="mask"></div>
														<img
															className="scale-with-grid"
															src="/assets/images/treatments/teeth-whitening.jpg"
															alt="Teeth Whitening"
															width="960"
															height="960"
														/>
													</div>
												</div>
											</div>

											<div className="column mcb-column two-third column_column">
												<div className="column_attr clearfix">
													<h4>How It Works</h4>
													<p>
														Uses peroxide-based bleaching agents—such as hydrogen or carbamide peroxide—to oxidise and lighten tooth
														stains. Can be done in-clinic using high-strength gels and protective measures.
													</p>

													<h4>What to Expect</h4>
													<ul>
														<li>Initial assessment including dental history and shade guide check.</li>
														<li>In-office procedure typically lasting 1–1.5 hours.</li>
														<li>Results vary—shades can improve by several tones in one session.</li>
														<li>Post-treatment sensitivity is common but usually subsides in a few days.</li>
													</ul>

													<h4>Benefits</h4>
													<ul>
														<li>Quick, noticeable whitening results.</li>
														<li>Clinically supervised for safety and effectiveness.</li>
														<li>Custom trays and maintenance options available for long-term upkeep.</li>
													</ul>

													<h4>Possible Side Effects</h4>
													<ul>
														<li>Temporary tooth sensitivity—often mild to moderate, lasting up to ~39 days.</li>
														<li>May irritate gums or mucous membranes if protective measures fail.</li>
														<li>Over-bleaching risks enamel weakening or "bleached effect".</li>
													</ul>
												</div>
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<div className="column one column_pricing_item">
														<div className="pricing-box custom-pricing-box pricing-box-table pricing-box-featured">
															<div className="plan-header">
																<h3>Pricing</h3>
															</div>
															<div className="plan-inside clearfix">
																<hr className="bg-theme" />
																<ul>
																	{prices.map(({ label, value }, idx) => (
																		<li key={idx} className="clearfix" style={{ paddingLeft: '5%', paddingRight: '5%' }}>
																			<div>
																				<strong>{label}</strong>
																			</div>
																			<div style={{ whiteSpace: 'pre-line' }}>{value}</div>
																		</li>
																	))}
																</ul>
																<hr className="bg-theme" />
															</div>
															<div className="plan-footer">
																<Link to="/book-now" className="button button_left button_theme button_js">
																	<span className="button_icon">
																		<i className="icon-basket"></i>
																	</span>
																	<span className="button_label">BOOK NOW</span>
																</Link>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>

											<div className="column one column_slider">
												<div className="column_attr clearfix hrmargin_b_60">
													<h2 className="hrmargin_b_60" style={{ textAlign: 'center' }}>
														Results
													</h2>
													<div className="content_slider">
														<ul className="content_slider_ul">
															<li className="content_slider_li_1">
																<img
																	width="100%"
																	height="auto"
																	src="/assets/images/treatments/teeth-whitening-result.jpg"
																	alt="Teeth Whitening Result"
																	className="scale-with-grid wp-post-image"
																/>
															</li>
														</ul>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<h2 className="hrmargin_b_60" style={{ textAlign: 'center' }}>
														After-Care
													</h2>
													<ul>
														<li>
															Avoid pigmented foods and drinks for 48 hours (coffee, red wine, etc.) to maintain whitening results
															and prevent staining.
														</li>
														<li>
															Use desensitising toothpaste if sensitivity occurs, especially in the first few days to soothe
															discomfort effectively.
														</li>
														<li>
															Consider custom trays for at-home care to prolong brightness between treatments and maintain
															consistency.
														</li>
														<li>
															Follow your practitioner's instructions and attend recommended check-ups to ensure the best
															long-term outcome.
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</DefaultLayout>
	);
};

export default TeethWhiteningPage;
